export default __webpack_public_path__ + "static/media/vert-horizontal.7dfd0f07.svg";